import * as THREE from 'three';
import { World } from './World';
import { Npc } from '../character/Npc';
import { NpcSpawnService } from './NpcSpawnService';

export class CopSpawnPoint {
    constructor(private position: THREE.Vector3, private npcSpawnService: NpcSpawnService) {}

    public spawn(world: World, onSpawned?: (cop: Npc) => void): void {
        const modelPath = this.npcSpawnService.pickCopModel();
        this.npcSpawnService.loader.load(`../../${modelPath}`, (model) => {
            const cop = new Npc(model, world.animationClips);
            cop.traverse((object) => {
                object.frustumCulled = false;
            });

            cop.setPosition(this.position.x, this.position.y, this.position.z);

            const forward = new THREE.Vector3(0, 0, 1);
            cop.setOrientation(forward, true);

            const geometry = new THREE.BoxGeometry(0.3, 1.7, 0.3);
            const material = new THREE.MeshBasicMaterial({ color: 0x0000ff });
            geometry.name = 'collisionCopGeometry';
            material.transparent = true;
            material.opacity = 0;

            const mesh = new THREE.Mesh(geometry, material);
            mesh.name = `cop${THREE.MathUtils.generateUUID().substring(0, 3)}`;
            cop.add(mesh);
            cop.isPlayer = false;
            world.add(cop);
            cop.initCop(world);
            onSpawned?.(cop);
        });
    }
}
